"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var spacesOutsideParentheses = exports.spacesOutsideParentheses = / (?=([^()]*\([^()]*\))*[^()]*$)/g;
var unsafeClassNameCharacters = exports.unsafeClassNameCharacters = /[^_a-zA-Z0-9-]/g;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlscy9yZWdleC5qcyJdLCJuYW1lcyI6WyJzcGFjZXNPdXRzaWRlUGFyZW50aGVzZXMiLCJ1bnNhZmVDbGFzc05hbWVDaGFyYWN0ZXJzIl0sIm1hcHBpbmdzIjoiOzs7OztBQUFPLElBQU1BLDhEQUEyQixrQ0FBakM7QUFDQSxJQUFNQyxnRUFBNEIsaUJBQWxDIiwiZmlsZSI6InJlZ2V4LmpzIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGNvbnN0IHNwYWNlc091dHNpZGVQYXJlbnRoZXNlcyA9IC8gKD89KFteKCldKlxcKFteKCldKlxcKSkqW14oKV0qJCkvZ1xuZXhwb3J0IGNvbnN0IHVuc2FmZUNsYXNzTmFtZUNoYXJhY3RlcnMgPSAvW15fYS16QS1aMC05LV0vZ1xuIl19


//////////////////
// WEBPACK FOOTER
// ./~/ui-box/lib/utils/regex.js
// module id = 50
// module chunks = 0